<!--
  Der Offline-Block eines Projekts. Eigener Klick-Stopper, damit ein Klick auf
  einen Knopf nicht zugleich die umgebende Karte auslöst.
-->
<div class="offline-projekt" [ngClass]="anzeige.klasse" (click)="$event.stopPropagation()">

  <!-- ZUSTAND -->
  <div class="zustand" [matTooltip]="tooltip" matTooltipClass="offline-projekt-tooltip">
    <mat-icon class="zustand-icon" [class.dreht]="zustand === 'synchronisiert'">{{ anzeige.icon }}</mat-icon>

    <div class="zustand-text">
      <span class="zustand-titel">{{ anzeige.text }}</span>

      <!-- Stand und letzte Synchronisierung – nur bei vorhandenem Bestand -->
      <span class="zustand-meta" *ngIf="verfuegbar && !laedt">
        Stand {{ status?.downloadedAtUtc | date:'dd.MM.yyyy HH:mm' }}
        <ng-container *ngIf="status?.lastSyncAtUtc">
          · zuletzt synchronisiert {{ status?.lastSyncAtUtc | date:'dd.MM.yyyy HH:mm' }}
        </ng-container>
        <ng-container *ngIf="!status?.lastSyncAtUtc">
          · noch nicht synchronisiert
        </ng-container>
      </span>

      <span class="zustand-meta" *ngIf="verfuegbar && !laedt">
        {{ status?.listen }} {{ status?.listen === 1 ? 'Messstellenliste' : 'Messstellenlisten' }}
        · {{ status?.spsListen }} SPS-{{ status?.spsListen === 1 ? 'Liste' : 'Listen' }}
      </span>

      <span class="zustand-meta zustand-fehlertext" *ngIf="zustand === 'fehler' && status?.fehlertext">
        {{ status?.fehlertext }}
      </span>

      <span class="zustand-meta zustand-fehlertext" *ngIf="status?.schemaVeraltet && !laedt">
        Die Offline-Daten stammen aus einer älteren Programmversion – bitte aktualisieren.
      </span>
    </div>
  </div>

  <!-- FORTSCHRITT -->
  <div class="fortschritt" *ngIf="laedt && status?.fortschritt as f">
    <mat-progress-bar mode="determinate" [value]="fortschrittProzent"></mat-progress-bar>
    <span class="fortschritt-text">
      {{ f.schritt }}
      <ng-container *ngIf="f.gesamt > 1"> · {{ f.erledigt }} von {{ f.gesamt }} Teilen</ng-container>
    </span>
  </div>

  <!-- AKTIONEN -->
  <div class="aktionen" *ngIf="!laedt">

    <!-- Noch nicht heruntergeladen -->
    <button mat-raised-button color="primary" type="button" class="aktion-haupt"
      *ngIf="!verfuegbar && !seiteIstOffline"
      (click)="herunterladen($event)"
      matTooltip="Alle Messstellenlisten, SPS-Listen, Prüfungen und QR-Codes dieses Projekts auf dieses Gerät laden">
      <mat-icon>cloud_download</mat-icon>
      Offline verfügbar machen
    </button>

    <span class="nicht-moeglich" *ngIf="!verfuegbar && seiteIstOffline">
      <mat-icon inline>cloud_off</mat-icon>
      Zum Herunterladen wird eine Verbindung gebraucht.
    </span>

    <!-- Bereits heruntergeladen -->
    <ng-container *ngIf="verfuegbar">

      <button mat-stroked-button color="primary" type="button"
        *ngIf="(status?.ausstehend ?? 0) > 0 || zustand === 'fehler'"
        [disabled]="beschaeftigt || seiteIstOffline"
        (click)="synchronisieren($event)"
        matTooltip="Ausstehende Änderungen jetzt an den Server übertragen">
        <mat-icon>sync</mat-icon>
        Jetzt synchronisieren
      </button>

      <button mat-raised-button color="primary" type="button"
        *ngIf="(status?.konflikte ?? 0) > 0 || (status?.fehlgeschlagen ?? 0) > 0"
        (click)="konflikte($event)"
        matTooltip="Offene Konflikte und abgelehnte Änderungen ansehen und entscheiden">
        <mat-icon>merge_type</mat-icon>
        Konflikte ansehen
        <span class="zaehler">{{ (status?.konflikte ?? 0) + (status?.fehlgeschlagen ?? 0) }}</span>
      </button>

      <button mat-stroked-button type="button"
        [disabled]="seiteIstOffline || beschaeftigt"
        (click)="herunterladen($event)"
        matTooltip="Erst ausstehende Änderungen senden, danach den aktuellen Serverstand laden">
        <mat-icon>cloud_sync</mat-icon>
        Aktualisieren
      </button>

      <button mat-button color="warn" type="button"
        [disabled]="beschaeftigt || offen > 0"
        (click)="entfernen($event)"
        [matTooltip]="offen > 0
          ? 'Erst synchronisieren – es gibt noch nicht übertragene Änderungen'
          : 'Lokale Kopie dieses Projekts von diesem Gerät löschen'">
        <mat-icon>delete_sweep</mat-icon>
        Vom Gerät entfernen
      </button>

    </ng-container>

  </div>

</div>
